module.exports = __webpack_public_path__ + "img/Paypal providor_mobile-screenshot.1a0f4235.png";